import { useActionBarOffset } from "./action-bar-offset";

// A little extra space so content settles above the bar's shadow rather than
// flush against it.
const BREATHING_GAP = 16;

/**
 * Reserves scroll space at the bottom of a page for the fixed action bar.
 * Render it as the last child of a page's scrollable content. It reads the
 * live bar height, so it collapses to nothing when no bar is on screen (e.g.
 * a role without actions, or while a side drawer has taken over the bar).
 */
export const ActionBarSpacer = () => {
  const offset = useActionBarOffset();

  return (
    <div aria-hidden style={{ height: offset ? offset + BREATHING_GAP : 0 }} />
  );
};
